var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.causer)?_c('strong',[_vm._v("System")]):(_vm.causer.id == _vm.$authUser.id)?_c('strong',[_vm._v("You")]):_c('strong',[_vm._v(_vm._s(_vm.causer.name))])}
var staticRenderFns = []

export { render, staticRenderFns }